import { addHeaderHash } from '@zet/network'

export function clearLoginHash() {
  if (sessionStorage.getItem('hash')) {
    sessionStorage.removeItem('hash')
  }
}
export function setLoginHash(hash: string) {
  sessionStorage.setItem('hash', hash)
}

export function getLoginHash() {
  const params = new URLSearchParams(window?.location?.search)
  return params?.get?.('hash') || sessionStorage?.getItem?.('hash')
}

export function getTagType() {
  const params = new URLSearchParams(window?.location?.search)
  return params?.get?.('tag')
}

export function replaceLoginHash(encodedHash: string) {
  const decodedHash = decodeURIComponent(encodedHash)
  setLoginHash(decodedHash)
  addHeaderHash(encodedHash)
}

export function initHash() {
  const hash = getLoginHash()
  if (!hash) {
    return false
  }
  setLoginHash(hash)
  const encodedHash = encodeURIComponent(hash)
  addHeaderHash(encodedHash)
  return true
}
